import React from "react";

import {
  pickPercent,
  getPerformanceValues,
  getInstructorsDashboardPerformanceColors
} from "components/analysis/utils";
import OnePanelChart from "components/analysis/OnePanelChart";
import DivFormula from "components/analysis/DivFormula";
import Text from "components/analysis/Text";

const ReturnOnAssets = ({
  teams,
  metricsReports,
  currentGame,
  roundNumber
}) => {
  const chartData = getPerformanceValues(
    pickPercent(teams, metricsReports, "roa")
  );
  const colors = getInstructorsDashboardPerformanceColors(chartData.length);

  return (
    <OnePanelChart
      title="Return on Assets"
      vertical
      suffix="%"
      data={chartData}
      customColors={colors}
      showCategoryLabels={true}
      instructorData={{ currentGame, roundNumber, type: "return-on-assets" }}
    >
      <Text>
        Investors use this metric to measure how well a business has used its
        assets to generate profits. The higher the ROA, the better.
      </Text>
      <DivFormula
        name1="ROA"
        name2="NET PROFITS"
        name3="AVERAGE TOTAL ASSETS"
      />
    </OnePanelChart>
  );
};

export default ReturnOnAssets;



// WEBPACK FOOTER //
// ./src/instructor/components/dashboard/return-on-assets.js